<template>
    <div class="selection-bar">
        <span class="selection-count">{{ $tc('company.students_selected', selectedCount, { n: selectedCount }) }}</span>

        <button-tooltip top :tooltip="$t('company.change_coach')">
            <template v-slot:activator="{ on, attrs }">
                <button type="button" class="act-btn bulk" :disabled="!selectedCount" v-bind="attrs" v-on="on"
                    @click="$emit('bulk:coach')">
                    <v-icon size="17">mdi-swap-horizontal</v-icon>
                </button>
            </template>
        </button-tooltip>

        <button-tooltip top :tooltip="$t('tooltips.unlink_student')">
            <template v-slot:activator="{ on, attrs }">
                <button type="button" class="act-btn danger" :disabled="!selectedCount" v-bind="attrs" v-on="on"
                    @click="$emit('bulk:unlink')">
                    <v-icon size="17">mdi-link-variant-off</v-icon>
                </button>
            </template>
        </button-tooltip>

        <button-tooltip top :tooltip="$t('common.cancel')">
            <template v-slot:activator="{ on, attrs }">
                <button type="button" class="act-btn" v-bind="attrs" v-on="on" @click="$emit('exit')">
                    <v-icon size="17">mdi-close</v-icon>
                </button>
            </template>
        </button-tooltip>
    </div>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";

export default {
    name: "AdminSelectionBar",
    components: { ButtonTooltip },
    props: {
        selectedCount: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style scoped>
.selection-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 6px 4px 12px;
    border-radius: 10px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
}

.selection-count {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    white-space: nowrap;
}

.act-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--v-txtSecondary-base);
    transition: background 0.15s, color 0.15s, opacity 0.15s;
}

.act-btn:hover:not(:disabled) {
    background: var(--v-surface-base);
    color: var(--v-txtPrimary-base);
}

.act-btn:disabled {
    opacity: 0.4;
    cursor: default;
}

.theme--dark .act-btn.bulk:not(:disabled) {
    color: var(--v-primary-base);
}

.theme--light .act-btn.bulk:not(:disabled) {
    color: var(--v-accent-base);
}

.act-btn.danger:not(:disabled) {
    color: var(--v-error-base);
}
</style>
